import { useAppSelector } from "../../../../store/store";
import GetHeroIcon from "@assessment/utils/getHeroIcons";

import { cn } from "../../../../utils/cn";

import { QuestionProgressStatus } from "../../../../types/assessmentOngoing";

interface Props {
  number: number;
  questionId: string;
  status: QuestionProgressStatus["status"];
  flagged: boolean;
  clickHandler: (id: string) => void;
  disabled: boolean;
}
const QuestionBlock = ({
  number,
  questionId,
  status,
  flagged,
  clickHandler,
  disabled
}: Props) => {
  const applyReviewIndicationStyling = useAppSelector(
    (state) => state.AssessmentSlice.applyReviewIndicationStyling
  );
  return (
    <div
      onClick={() => clickHandler(String(questionId))}
      className={cn(
        "w-16 h-16 rounded-xl flex justify-center items-center cursor-pointer flex-shrink-0",
        status === "completed" && "bg-[#F0FDF4] text-[#00875D]",
        status === "unanswered" && "bg-secondary-bg text-secondary",
        status === "not_started" && "bg-secondary-bg text-secondary",
        applyReviewIndicationStyling &&
          (flagged || status === "unanswered") &&
          " shadow-neutral-200 shadow-block",
        disabled && "bg-secondary-bg text-secondary opacity-40 cursor-progress"
      )}
    >
      {flagged && (
        <GetHeroIcon
          name="FlagIcon"
          className="absolute bottom-5 left-7 w-4 h-4 text-[#AA6207] drop-shadow-sm"
        />
      )}
      <span className="text-2xl font-semibold leading-7">{number}</span>
    </div>
  );
};

export default QuestionBlock;
